"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
exports["default"] = ramda_1.pick([
    'alt',
    'crossorigin',
    'height',
    'ismap',
    'loading',
    'longdesc',
    'sizes',
    'src',
    'srcset',
    'usemap',
    'width',
]);
//# sourceMappingURL=img.js.map